const {
  VUE_APP_SUPABASE_URL,
  VUE_APP_SUPABASE_ANON_KEY
} = process.env

export const SUPABASE_URL = VUE_APP_SUPABASE_URL
export const SUPABASE_ANON_KEY = VUE_APP_SUPABASE_ANON_KEY

console.log('supabase', { SUPABASE_URL, env: { ...process.env } })
